import styled from 'styled-components';

const ContentsFinishedContainer = styled.div``;

export { ContentsFinishedContainer };
